import { AxiosResponse } from 'axios';
import http from '../../http-common';
import TokenService from './token.service';
import { AvailableCustomFields, ConfigObject, HealthScoreConfig } from './health-score-config';

class HealthScoreService {
    public getConfig(client_id: string): Promise<AxiosResponse<HealthScoreConfig>> {
        return http.get(`/api/client/${client_id}/healthScore/config`, { headers: TokenService.getAuthHeader() });
    }
    public validateConfig(client_id: string, overrides: ConfigObject): Promise<AxiosResponse<unknown>> {
        return http.post(`/api/client/${client_id}/healthScore/config:validate`, { overrides }, { headers: TokenService.getAuthHeader() });
    }
    /** Configuration enregistrée ; 409 si elle a changé depuis la lecture de `expectedVersion`. */
    public updateConfig(client_id: string, overrides: ConfigObject, expectedVersion: number): Promise<AxiosResponse<HealthScoreConfig>> {
        return http.put(`/api/client/${client_id}/healthScore/config`, { overrides, expectedVersion }, { headers: TokenService.getAuthHeader() });
    }
    /** Configuration revenue aux défauts. */
    public resetConfig(client_id: string): Promise<AxiosResponse<HealthScoreConfig>> {
        return http.delete(`/api/client/${client_id}/healthScore/config`, { headers: TokenService.getAuthHeader() });
    }
    public getCustomFields(client_id: string): Promise<AxiosResponse<AvailableCustomFields[]>> {
        return http.get(`/api/client/${client_id}/healthScore/custom-fields`, { headers: TokenService.getAuthHeader() });
    }
}

export default new HealthScoreService();
